module.exports = __webpack_public_path__ + "img/sound.9cfdd378.svg";